// src/AssignmentModal.js - CORRETTO E FUNZIONANTE

import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Select from 'react-select';

// 1. AGGIUNTO 'assignments' QUI SOTTO TRA LE PARENTESI GRAFFE
export function AssignmentModal({ modalData, rooms, doctors, services, assignments, onSave, onClose, allEquipment, 
    allSpecialties }) {
    const [roomId, setRoomId] = useState('');
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [startTime, setStartTime] = useState('09:00');
    const [endTime, setEndTime] = useState('10:00');

    const [selectedDays, setSelectedDays] = useState([]);
    const [validFrom, setValidFrom] = useState('');
    const [validUntil, setValidUntil] = useState(''); 
    const [recurrenceType, setRecurrenceType] = useState('single'); 
    const [recurrenceInterval, setRecurrenceInterval] = useState(2); 

    const [selectedCollaborators, setSelectedCollaborators] = useState([]);
    const [isFreeRoom, setIsFreeRoom] = useState(false); // 🆕 Stanza Libera: nessun medico/collaboratore
    // 🎯 FIX 1B: Stati per la gestione delle prestazioni permesse nel turno
    const [doctorAllowedServices, setDoctorAllowedServices] = useState([]); // Le prestazioni che il medico SA FARE
    const [selectedAllowedServices, setSelectedAllowedServices] = useState([]); // Le prestazioni che FARÀ in QUESTO turno

    const [roomSuitability, setRoomSuitability] = useState({ 
        suitable: true, 
        message: '',
        missingEquipment: [], 
        alternativeRooms: []  
    });

    const [showAlternativesModal, setShowAlternativesModal] = useState(false);

    const daysOfWeekOptions = [
        { label: 'Lunedì', value: 1 }, { label: 'Martedì', value: 2 },
        { label: 'Mercoledì', value: 3 }, { label: 'Giovedì', value: 4 },
        { label: 'Venerdì', value: 5 }, { label: 'Sabato', value: 6 }
    ];

    const doctorOptions = [...doctors]
        .sort((a, b) => a.lastName.localeCompare(b.lastName))
        .map(doc => ({ value: doc.id, label: `${doc.firstName} ${doc.lastName}` }));

    const recurrenceOptions = [
        { value: 'single', label: 'Solo questo giorno' },
        { value: 'weekly', label: 'Ogni settimana' },
        { value: 'interval', label: 'Settimane alterne' }
    ];

    const isTimeOverlapping = (start1, end1, start2, end2) => {
        const s1 = moment(start1, 'HH:mm').diff(moment().startOf('day'), 'minutes');
        const e1 = moment(end1, 'HH:mm').diff(moment().startOf('day'), 'minutes');
        const s2 = moment(start2, 'HH:mm').diff(moment().startOf('day'), 'minutes');
        const e2 = moment(end2, 'HH:mm').diff(moment().startOf('day'), 'minutes');
        return s1 < e2 && e1 > s2;
    };

    useEffect(() => {
        if (modalData.assignment) {
            const { assignment, day } = modalData;
            setRoomId(assignment.roomId || '');
            setIsFreeRoom(!!assignment.isFreeRoom); // 🆕
            setSelectedDoctor(assignment.isFreeRoom ? null : doctorOptions.find(opt => opt.value === assignment.doctorId));
            setStartTime(assignment.startTime || '09:00');
            setEndTime(assignment.endTime || '10:00');
            setValidFrom(day ? day.format('YYYY-MM-DD') : assignment.validFrom);
            setValidUntil(assignment.validUntil || ''); 

            const currentDayValues = (assignment.daysOfWeek || []).map(dayValue =>
                daysOfWeekOptions.find(opt => opt.value === dayValue)
            ).filter(Boolean);
            setSelectedDays(currentDayValues);

            if (!assignment.isRecurring || (assignment.validFrom === assignment.validUntil)) { 
                 setRecurrenceType('single');
                 const singleDayOption = daysOfWeekOptions.find(opt => opt.value === moment(assignment.validFrom).isoWeekday());
                 if(singleDayOption) setSelectedDays([singleDayOption]);
            } else if (assignment.isRecurring && assignment.recurrenceInterval === 1) {
                 setRecurrenceType('weekly');
            } else if (assignment.isRecurring && assignment.recurrenceInterval > 1) {
                 setRecurrenceType('interval');
                 setRecurrenceInterval(assignment.recurrenceInterval);
            } else { 
                setRecurrenceType('weekly');
                setRecurrenceInterval(1);
            }

            if (assignment.collaboratorIds) {
                const collaborators = doctorOptions.filter(opt => assignment.collaboratorIds.includes(opt.value));
                setSelectedCollaborators(collaborators);
            }
                } else {
            setRoomId(modalData.preselectedRoomId || (rooms.length > 0 ? rooms[0].id : ''));
            setIsFreeRoom(false); // 🆕
            setSelectedDoctor(null);
            setSelectedCollaborators([]);
            setStartTime(modalData.preselectedStartTime || '09:00');
            setEndTime(modalData.preselectedEndTime || '10:00');
            
            let initialDate = moment();
            if (modalData.day) {
                initialDate = modalData.day;
            }
            
            setValidFrom(initialDate.format('YYYY-MM-DD'));
            setValidUntil(initialDate.clone().add(1, 'year').format('YYYY-MM-DD'));

            const initialDayOption = daysOfWeekOptions.find(opt => opt.value === initialDate.isoWeekday());
            if(initialDayOption) setSelectedDays([initialDayOption]);
            
            setRecurrenceType('single'); 
            setRecurrenceInterval(2);
        }
    }, [modalData, rooms, doctors]);

    useEffect(() => {
    // Reset immediato se mancano i dati minimi per il controllo
    // 🆕 In modalità Stanza Libera non serve un medico per far girare
    // il controllo macchinari — dipende solo dalle prestazioni scelte a mano.
    if ((!selectedDoctor && !isFreeRoom) || !roomId || !rooms || !allEquipment || !services) {
        setRoomSuitability({
            suitable: true, message: '',
            missingEquipment: [], alternativeRooms: []
        });
        return;
    }

    // ─── NUOVA LOGICA: controllo basato esclusivamente sulle prestazioni ───
    //
    // Regola: se nessuna prestazione del turno richiede un macchinario,
    // la stanza è sempre idonea (zero ridondanza con la specialistica).
    //
    // Passi:
    //   1. Considera solo le prestazioni abilitate per questo turno
    //   2. Tra quelle, tieni solo quelle con requiredEquipmentId valorizzato
    //   3. Costruisci il set dei macchinari richiesti (AND: devono esserci tutti)
    //   4. Confronta con i macchinari della stanza selezionata
    // ──────────────────────────────────────────────────────────────────────

    // 1. Se non ci sono prestazioni abilitate per questo turno,
    //    non c'è nulla da verificare → stanza sempre idonea
    if (!selectedAllowedServices || selectedAllowedServices.length === 0) {
        setRoomSuitability({
            suitable: true,
            message: '✅ Nessuna prestazione specifica richiesta per questo turno.',
            missingEquipment: [], alternativeRooms: []
        });
        return;
    }

    // 2. Costruisco il set dei macchinari richiesti dalle prestazioni
    //    abilitate in questo turno (solo quelle con requiredEquipmentId)
    const requiredEquipmentIds = new Set();
    const requiredEquipmentDetails = [];

    selectedAllowedServices.forEach(serviceId => {
        const service = services.find(s => s.id === serviceId);
        // Ignoro le prestazioni senza macchinario richiesto
        if (!service || !service.requiredEquipmentId) return;

        const equipment = allEquipment.find(
            e => e.id === service.requiredEquipmentId
        );
        if (!equipment) return;

        // Evito duplicati (più prestazioni potrebbero richiedere lo stesso macchinario)
        if (!requiredEquipmentIds.has(equipment.id)) {
            requiredEquipmentIds.add(equipment.id);
            requiredEquipmentDetails.push({
                id: equipment.id,
                name: equipment.name,
                // Traccio quale prestazione ha richiesto questo macchinario
                // (utile per il messaggio di errore)
                requestedByService: service.nome
            });
        }
    });

    // 3. Se nessuna prestazione richiede macchinari → stanza sempre idonea
    if (requiredEquipmentIds.size === 0) {
        setRoomSuitability({
            suitable: true,
            message: '✅ Le prestazioni selezionate non richiedono macchinari specifici.',
            missingEquipment: [], alternativeRooms: []
        });
        return;
    }

    // 4. Confronto con i macchinari della stanza selezionata
    const room = rooms.find(r => r.id === roomId);
    if (!room) return;

    const roomEquipmentIds = new Set(room.equipmentIds || []);
    const missingEquipment = requiredEquipmentDetails.filter(
        equip => !roomEquipmentIds.has(equip.id)
    );

    if (missingEquipment.length === 0) {
        setRoomSuitability({
            suitable: true,
            message: '✅ Stanza idonea per le prestazioni selezionate.',
            missingEquipment: [], alternativeRooms: []
        });
        return;
    }

    // 5. Stanza non idonea: cerco stanze alternative libere e attrezzate
    const alternativeRooms = findAlternativeRooms(
        rooms, roomId, requiredEquipmentIds,
        startTime, endTime, selectedDays,
        validFrom, validUntil, recurrenceType
    );

    setRoomSuitability({
        suitable: false,
        message: `⚠️ Macchinari mancanti: ${missingEquipment.map(e => e.name).join(', ')}`,
        missingEquipment,
        alternativeRooms
    });

    // Il controllo si riesegue ogni volta che cambiano stanza, prestazioni,
    // orari o date del turno
    }, [selectedDoctor, isFreeRoom, roomId, rooms, allEquipment, services,
        selectedAllowedServices, startTime, endTime,
        selectedDays, validFrom, validUntil, recurrenceType, assignments]);

    const findAlternativeRooms = (allRooms, currentRoomId, requiredEquipmentIds, timeStart, timeEnd, days, dateFrom, dateUntil, recurrence) => {
        // 1. Filtra per Macchinari
        const equipmentSuitableRooms = allRooms.filter(room => {
            if (room.id === currentRoomId) return false;
            const roomEquipIds = new Set(room.equipmentIds || []);
            for (let equipId of requiredEquipmentIds) {
                if (!roomEquipIds.has(equipId)) return false;
            }
            return true;
        });

        // 2. Filtra per Disponibilità Oraria
        const availableRooms = equipmentSuitableRooms.filter(room => {
            if (!assignments) return true; // Se non ci sono assegnazioni, è libera

            const hasConflict = assignments.some(existing => {
                if (existing.roomId !== room.id) return false;
                if (modalData.assignment && existing.id === modalData.assignment.id) return false;

                if (!isTimeOverlapping(timeStart, timeEnd, existing.startTime, existing.endTime)) return false;

                const daysToCheck = days.map(d => d.value);
                const existingDays = existing.daysOfWeek || [];
                
                const commonDays = daysToCheck.filter(d => existingDays.includes(d));
                if (commonDays.length === 0) return false;

                const start1 = moment(dateFrom);
                const end1 = dateUntil ? moment(dateUntil) : start1;
                const start2 = moment(existing.validFrom);
                const end2 = existing.validUntil ? moment(existing.validUntil) : start2;

                if (end1.isBefore(start2) || start1.isAfter(end2)) return false;

                return true; // C'è conflitto
            });

            return !hasConflict;
        });

        return availableRooms.map(room => ({
            id: room.id,
            name: room.name,
            equipment: room.equipmentIds || []
        }));
    };

    // 🎯 FIX 2: useEffect dedicato ESCLUSIVAMENTE al caricamento delle prestazioni consentite.
    // Si attiva quando cambia il medico titolare selezionato, i collaboratori, o si apre il modale.
    useEffect(() => {
        // 🆕 Stanza Libera: non c'è un medico da cui derivare le prestazioni —
        // l'elenco selezionabile diventa TUTTE le prestazioni del centro,
        // scelte manualmente dall'admin.
        if (isFreeRoom) {
            if (!services) { setDoctorAllowedServices([]); setSelectedAllowedServices([]); return; }
            setDoctorAllowedServices(services);
            if (modalData.assignment && modalData.assignment.isFreeRoom && modalData.assignment.allowedServices) {
                setSelectedAllowedServices(modalData.assignment.allowedServices);
            } else {
                setSelectedAllowedServices([]);
            }
            return;
        }

        if (!selectedDoctor || !services || !doctors) {
            setDoctorAllowedServices([]);
            setSelectedAllowedServices([]);
            return;
        }

        const doctor = doctors.find(d => d.id === selectedDoctor.value);
        if (doctor) {
            // 🐛 FIX: prima qui c'erano SOLO le prestazioni del titolare. Se aggiungevi un
            // collaboratore con prestazioni diverse, quel collaboratore restava sempre
            // "non autorizzato" in questa assegnazione (niente slot disponibili in Agenda),
            // perché la sua terapia non compariva mai nell'elenco selezionabile qui.
            // Ora uniamo le prestazioni del titolare + di TUTTI i collaboratori selezionati.
            const collaboratorDoctors = selectedCollaborators
                .map(c => doctors.find(d => d.id === c.value))
                .filter(Boolean);

            const allPrestazioniIds = new Set(doctor.prestazioniAssegnate || []);
            collaboratorDoctors.forEach(collabDoc => {
                (collabDoc.prestazioniAssegnate || []).forEach(id => allPrestazioniIds.add(id));
            });

            const globalDoctorServices = services.filter(srv => allPrestazioniIds.has(srv.id));
            setDoctorAllowedServices(globalDoctorServices);

            // Se stiamo modificando un turno, e il medico è lo stesso del turno salvato, carica i suoi dati
            if (modalData.assignment && modalData.assignment.doctorId === selectedDoctor.value && modalData.assignment.allowedServices) {
                setSelectedAllowedServices(modalData.assignment.allowedServices);
            } else {
                // Se è un nuovo inserimento, o abbiamo appena cambiato medico/collaboratori, spunta tutte di default
                setSelectedAllowedServices(globalDoctorServices.map(srv => srv.id));
            }
        }
    }, [isFreeRoom, selectedDoctor, selectedCollaborators, modalData.assignment, doctors, services]);

    const prepareSaveData = (overrideRoomId = null) => {
        const collaboratorIds = selectedCollaborators.map(c => c.value);
        const daysOfWeekValues = selectedDays.map(dayOption => dayOption.value);
        const finalRoomId = overrideRoomId || roomId;

        let finalValidUntil = '';
        let finalIsRecurring = false;
        let finalRecurrenceInterval = 1;
        let finalDaysOfWeek = []; 

        if (recurrenceType === 'single') {
            finalValidUntil = validFrom;
            finalIsRecurring = false;
            finalDaysOfWeek = [moment(validFrom).isoWeekday()];
        } else {
            finalValidUntil = validUntil;
            finalIsRecurring = true;
            finalDaysOfWeek = daysOfWeekValues; 
            if (recurrenceType === 'weekly') {
                finalRecurrenceInterval = 1;
            } else {
                finalRecurrenceInterval = recurrenceInterval;
            }
        }

        return {
            id: modalData.assignment?.id,
            roomId: finalRoomId,
            doctorId: isFreeRoom ? null : selectedDoctor.value, // 🆕
            isFreeRoom: isFreeRoom, // 🆕
            startTime,
            endTime,
            daysOfWeek: finalDaysOfWeek,
            validFrom,
            validUntil: finalValidUntil,
            isRecurring: finalIsRecurring,
            recurrenceInterval: finalRecurrenceInterval,
            collaboratorIds: isFreeRoom ? [] : collaboratorIds, // 🆕
            allowedServices: selectedAllowedServices
        };
    };

    const handleSave = () => {
        if (!roomId || (!selectedDoctor && !isFreeRoom) || !startTime || !endTime || !validFrom) {
            alert('Tutti i campi principali sono obbligatori.');
            return;
        }
        if (startTime >= endTime) { 
            alert("L'orario di fine deve essere successivo a quello di inizio."); 
            return; 
        }

       if (!roomSuitability.suitable) {
            if (roomSuitability.alternativeRooms && roomSuitability.alternativeRooms.length > 0) {
                setShowAlternativesModal(true);
                return;
            } else {
                const forceMessage = `${roomSuitability.message}\n\nNessuna stanza alternativa disponibile.\n\nVuoi forzare l'assegnazione in questa stanza?`;
                if (!window.confirm(forceMessage)) return;
                // Se conferma, procediamo col salvataggio forzato (passiamo true)
                onSave(prepareSaveData()); // NON bypassare - fai controllare la sovrapposizione!
                return;
            }
        }

        onSave(prepareSaveData());
    };

    // --- 2. FIX CRITICO: Aggiunto parametro 'true' per bypassare i controlli ---
    const handleSelectAlternativeRoom = (alternativeRoomId) => {
        // 1. Chiudi il modale interno
        setShowAlternativesModal(false);
        // 2. Prepara i dati con la NUOVA stanza
        const data = prepareSaveData(alternativeRoomId);
        
        // 3. Chiama onSave SENZA bypassare il controllo della sovrapposizione!
        // La stanza alternativa deve comunque essere verificata per conflitti orari
        onSave(data, false); 
    };

    const handleForceOriginalRoom = () => {
        // 1. Chiudi il modale interno
        setShowAlternativesModal(false);
        // 2. Prepara i dati con la stanza ORIGINALE
        const data = prepareSaveData(roomId);
        
        // 3. Chiama onSave SENZA bypassare il controllo della sovrapposizione!
        // Anche se l'utente forza la stanza (macchinari), deve comunque controllare conflitti orari
        onSave(data, false);
    };
    // ------------------------------------------------------------------------

    const collaboratorOptions = doctorOptions.filter(opt => opt.value !== selectedDoctor?.value);

    const handleRecurrenceTypeSelect = (selectedOption) => {
        const newType = selectedOption.value;
        setRecurrenceType(newType);
        if (newType === 'single' || selectedDays.length === 0) {
            const currentDayOption = daysOfWeekOptions.find(opt => opt.value === moment(validFrom).isoWeekday());
            if (currentDayOption) setSelectedDays([currentDayOption]);
        }
    };

    return (
    <div className="modal" onMouseDown={onClose}>
        <div className="modal-content assignment-modal-content" onMouseDown={e => e.stopPropagation()}>

            <h3>{modalData.assignment ? 'Modifica Assegnazione' : 'Nuova Assegnazione'}</h3>

            <div className="modal-scrollable-form-content">
                <div style={{ textAlign: 'left', marginTop: '5px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div className="form-row">
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Stanza</label>
                            <select value={roomId} onChange={(e) => setRoomId(e.target.value)}>{rooms.map(room => <option key={room.id} value={room.id}>{room.name} - N. {room.number}</option>)}</select>
                        </div>
                    </div>

                    {/* 🆕 Stanza Libera: nessun medico/collaboratore, solo prestazioni ammesse manualmente */}
                    <div className="form-group" style={{ backgroundColor: '#fef9c3', padding: '12px 15px', borderRadius: '8px', border: '1px solid #fde047' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', margin: 0 }}>
                            <input
                                type="checkbox"
                                checked={isFreeRoom}
                                onChange={(e) => {
                                    setIsFreeRoom(e.target.checked);
                                    if (e.target.checked) { setSelectedDoctor(null); setSelectedCollaborators([]); }
                                }}
                                style={{ width: '18px', height: '18px', accentColor: '#ca8a04' }}
                            />
                            <span style={{ fontWeight: '700', color: '#854d0e' }}>Stanza Libera (nessun medico assegnato)</span>
                        </label>
                        <p style={{ fontSize: '0.8rem', color: '#854d0e', margin: '6px 0 0 28px' }}>
                            La stanza sarà prenotabile in base alla capienza, senza un medico titolare — scegli qui sotto
                            quali prestazioni sono ammesse. Nel Gestionale Clinico, al momento della prenotazione, si potrà
                            comunque assegnare un medico (tra quelli abilitati a quella prestazione) oppure lasciarla senza.
                        </p>
                    </div>

                    {!isFreeRoom && (
                        <>
                            <div className="form-row">
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>Medico Principale</label>
                                    <Select options={doctorOptions} value={selectedDoctor} onChange={setSelectedDoctor} placeholder="Cerca medico..." classNamePrefix="react-select" menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Collaboratori (Opzionale)</label>
                                <Select isMulti options={collaboratorOptions} value={selectedCollaborators} onChange={setSelectedCollaborators} placeholder="Aggiungi collaboratori..." classNamePrefix="react-select" isDisabled={!selectedDoctor} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                            </div>
                        </>
                    )}
                    <div className="form-row">
                        <div className="form-group" style={{ flex: 1 }}><label>Ora Inizio</label><input type="time" value={startTime} onChange={e => setStartTime(e.target.value)} /></div>
                        <div className="form-group" style={{ flex: 1 }}><label>Ora Fine</label><input type="time" value={endTime} onChange={e => setEndTime(e.target.value)} /></div>
                    </div>
                    {/* 🎯 FIX 4: Pannello Filtro Prestazioni Consentite per il Turno */}
                    {(selectedDoctor || isFreeRoom) && doctorAllowedServices.length > 0 && (
                        <div className="form-group" style={{ backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            <label style={{ color: '#1e3a8a', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Prestazioni Consentite in questo Turno
                                <span style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: 'normal' }}>
                                    (Deseleziona per bloccare le prenotazioni in questa fascia)
                                </span>
                            </label>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', marginTop: '10px' }}>
                                {doctorAllowedServices.map(srv => (
                                    <label key={srv.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem', cursor: 'pointer', margin: 0 }}>
                                        <input 
                                            type="checkbox"
                                            checked={selectedAllowedServices.includes(srv.id)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedAllowedServices([...selectedAllowedServices, srv.id]);
                                                } else {
                                                    setSelectedAllowedServices(selectedAllowedServices.filter(id => id !== srv.id));
                                                }
                                            }}
                                            style={{ accentColor: '#2563eb', width: '16px', height: '16px' }}
                                        />
                                        {srv.nome || srv.name}
                                    </label>
                                ))}
                            </div>
                        </div>
                    )}
                    { !roomSuitability.suitable && (
                        <div style={{ color: '#856404', fontWeight: 'bold', margin: '0', padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffeeba', borderRadius: '5px', fontSize: '0.9rem' }}>
                            {roomSuitability.message}
                        </div>
                    )}
                    <div className="recurrence-options">
                        <div className="form-row">
                             <div className="form-group" style={{ flex: 1 }}><label>A partire dal</label><input type="date" value={validFrom} onChange={e => setValidFrom(e.target.value)} /></div>
                            {recurrenceType !== 'single' && ( <div className="form-group" style={{ flex: 1 }}><label>Fino al (incluso)</label><input type="date" value={validUntil} onChange={e => setValidUntil(e.target.value)} /></div> )}
                            <div className="form-group" style={{ flex: recurrenceType !== 'single' ? 1 : 2 }}><label>Tipo Ripetizione</label><Select options={recurrenceOptions} value={recurrenceOptions.find(opt => opt.value === recurrenceType)} onChange={handleRecurrenceTypeSelect} classNamePrefix="react-select" menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} /></div>
                        </div>
                        {recurrenceType === 'interval' && ( <div className="form-group" style={{ alignSelf: 'flex-start' }}><label className="recurrence-interval-label">Ogni <input type="number" value={recurrenceInterval} onChange={e => setRecurrenceInterval(Number(e.target.value))} min="2" /> settimane</label></div> )}
                        {recurrenceType !== 'single' && ( <div className="form-group"><label>Nei giorni di</label><Select isMulti options={daysOfWeekOptions} value={selectedDays} onChange={setSelectedDays} placeholder="Seleziona giorni..." classNamePrefix="react-select" closeMenuOnSelect={false} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} /></div> )}
                    </div>
                </div> 
            </div> 
            <div className="modal-fixed-footer">
                <button onClick={handleSave} className="modal-button confirm-button">Salva</button>
                <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
            </div>
        </div>

        {/* MODALE STANZE ALTERNATIVE */}
        {showAlternativesModal && (
            <div className="modal" style={{ zIndex: 10000 }}>
                {/* AGGIUNTO onMouseDown={e => e.stopPropagation()} QUI SOTTO */}
                <div 
                    className="modal-content" 
                    style={{ maxWidth: '600px' }} 
                    onClick={e => e.stopPropagation()}
                    onMouseDown={e => e.stopPropagation()} 
                >
                    <h3>⚠️ Stanza Non Idonea</h3>
                    <div style={{ marginBottom: '20px' }}>
                        <p style={{ color: '#dc3545', fontWeight: 'bold' }}>{roomSuitability.message}</p>
                        <p>Macchinari mancanti:</p>
                        <ul style={{ marginLeft: '20px', color: '#666' }}>
                            {roomSuitability.missingEquipment.map(equip => (<li key={equip.id}>{equip.name}</li>))}
                        </ul>
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <h4>🔍 Stanze Alternative Disponibili ({roomSuitability.alternativeRooms.length})</h4>
                        {roomSuitability.alternativeRooms.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {roomSuitability.alternativeRooms.map(altRoom => {
                                    const equipmentNames = altRoom.equipment.map(eId => allEquipment.find(e => e.id === eId)?.name).filter(Boolean);
                                    return (
                                        <div 
                                            key={altRoom.id} 
                                            style={{ border: '2px solid #28a745', borderRadius: '8px', padding: '15px', cursor: 'pointer', transition: 'all 0.2s', backgroundColor: '#f8f9fa' }} 
                                            // Assicurati che onClick sia corretto qui
                                            onClick={() => handleSelectAlternativeRoom(altRoom.id)} 
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'} 
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <strong style={{ fontSize: '1.1rem' }}>{altRoom.name}</strong>
                                                <span style={{ backgroundColor: '#28a745', color: 'white', padding: '4px 12px', borderRadius: '12px', fontSize: '0.85rem' }}>✓ Idonea</span>
                                            </div>
                                            <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#666' }}>
                                                <strong>Macchinari:</strong> {equipmentNames.join(', ') || 'Nessuno'}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <p style={{ color: '#666', fontStyle: 'italic' }}>Nessuna stanza alternativa libera trovata con i macchinari richiesti.</p>
                        )}
                    </div>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button onClick={() => setShowAlternativesModal(false)} style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>Annulla</button>
                        
                        {/* Assicurati che anche questo onClick sia corretto */}
                        <button onClick={handleForceOriginalRoom} style={{ padding: '10px 20px', backgroundColor: '#ffc107', color: '#333', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>⚠️ Forza Stanza Originale</button>
                    </div>
                </div>
            </div>
        )}
    </div>
    );
}